import { TableGroupModel } from "./table-group.model";

export class CreateOrEditCapacityModel {
  public id: string;
  public name: string;
  public description: string;
  public venueId: string;
  public isDefault: boolean = true;
  public capacityGroups: Array<TableGroupModel>;
}
